module.exports = __webpack_public_path__ + "static/media/pupupBroadcast.d39d3149.png";